import React from 'react';

import * as ASentry from '@/thirdparty/ASentry';

import { useShopInfo2 } from './hooks';

export const useSentryShopEffect = () => {
  const { shopInfo } = useShopInfo2();

  React.useEffect(() => {
    ASentry.setShop({
      shopID: shopInfo.shopID,
      shopName: shopInfo.shopName,
    });
  }, [shopInfo.shopName, shopInfo.shopID]);
};
